import type { MtLitterGetLitterQuery, UpdateLitterInput } from '@gql/graphql';
import type { MtLitterPageFormValues } from '@presentation/pages';
import cleanDeep from 'clean-deep';
import { useCallback } from 'react';

export const useLitterUpdateBuilder = () => {
  const litterUpdateBuilder = useCallback(
    (
      values: Partial<MtLitterPageFormValues>,
      litter: NonNullable<
        NonNullable<MtLitterGetLitterQuery['accountMe']>['dogBreeder']
      >['litters'][number],
    ) => {
      const wasBorn = litter?.born ?? true;

      const data: UpdateLitterInput = {
        ...cleanDeep(
          {
            // General
            price: { set: values.price },
            priceFrom: { set: values.priceFrom },
            priceTo: { set: values.priceTo },
            fixedPrice: { set: values.fixedPrice },
            birthday: { set: values.birthday },
            availabilityDate: { set: values.availabilityDate },
            description: { set: values.description },

            // Litters
            malesLeftCount: { set: values.malesLeftCount },
            femalesLeftCount: { set: values.femalesLeftCount },
            ...(!wasBorn && {
              femalesCount: { set: values.femalesCount },
              malesCount: { set: values.malesCount },
            }),
            microchipped: { set: values.microchipped },
            vaccinated: { set: values.vaccinated },
            vaccinationDate: { set: values.vaccinationDate },
            pedigree: { set: values.pedigree },
            born: { set: values.born },
            dewormed: { set: values.dewormed },
            litterCode: { set: values.litterCode },
            dogBreedId: values.breedId,
            fatherParentId: values.FATHER ?? null,
            motherParentId: values.MOTHER ?? null,
          } as UpdateLitterInput,
          { nullValues: false },
        ),
      };

      return { data };
    },
    [],
  );

  return { litterUpdateBuilder };
};
